import React, { useState, forwardRef, useContext, useEffect } from 'react';
import axios from 'axios';
import { AuthorizeContext } from "../../RootContext";
import { api_url } from "../../authorize";
import logo from './../../img/lento_logo_transparent.png';

import moment from 'moment';
import MaterialTable from 'material-table';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';

import {
  Link,
  useParams
} from "react-router-dom";

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';


const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: 'calc(100vh - 72px)',
    boxSizing: 'border-box',
    padding: '34px 34px 56px',
    background: 'linear-gradient(180deg, #f8fbfc 0%, #eef4f7 100%)',
    color: '#173247',
    fontFamily: 'Arial, Helvetica, sans-serif',

    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px 38px',
    },
  },

  shell: {
    width: '100%',
    maxWidth: 1540,
    margin: '0 auto',
  },

  hero: {
    marginBottom: 24,
    padding: '30px 34px',
    borderRadius: 18,
    background: 'linear-gradient(135deg, #163f5b 0%, #0f7289 100%)',
    boxShadow: '0 16px 36px rgba(20, 69, 94, 0.16)',

    [theme.breakpoints.down('sm')]: {
      padding: '24px 22px',
    },
  },

  eyebrow: {
    margin: 0,
    color: 'rgba(255,255,255,0.72)',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
  },

  heroTitle: {
    margin: '6px 0 0',
    color: '#ffffff',
    fontSize: 34,
    lineHeight: 1.15,
    fontWeight: 800,
    letterSpacing: '-0.025em',

    [theme.breakpoints.down('xs')]: {
      fontSize: 28,
    },
  },

  heroSubtitle: {
    margin: '8px 0 0',
    color: 'rgba(255,255,255,0.82)',
    fontSize: 16,
    lineHeight: 1.5,
  },

  tableCard: {
    overflow: 'hidden',
    border: '1px solid #dce7ec',
    borderRadius: 18,
    background: '#ffffff',
    boxShadow: '0 14px 34px rgba(19, 62, 83, 0.08)',

    '& .MuiPaper-root': {
      boxShadow: 'none !important',
      borderRadius: '0 !important',
    },

    '& .MuiToolbar-root': {
      minHeight: '76px !important',
      paddingLeft: '24px !important',
      paddingRight: '24px !important',
      borderBottom: '1px solid #e6eef2',
      background: '#ffffff',
    },

    '& .MuiInputBase-root': {
      color: '#173247',
      fontSize: '16px !important',
    },

    '& .MuiInput-underline:before': {
      borderBottomColor: '#c7d7de !important',
    },

    '& .MuiInput-underline:after': {
      borderBottomColor: '#109bb9 !important',
    },

    '& .MuiTableHead-root .MuiTableCell-root': {
      background: '#f6f9fb !important',
      color: '#405d70 !important',
      fontSize: '15px !important',
      fontWeight: '800 !important',
      whiteSpace: 'nowrap',
      borderBottom: '1px solid #dde8ed !important',
    },

    '& .MuiTableBody-root .MuiTableRow-root': {
      transition: 'background 120ms ease',
    },

    '& .MuiTableBody-root .MuiTableRow-root:hover': {
      background: '#f8fbfc !important',
    },

    '& .MuiTableBody-root .MuiTableCell-root': {
      color: '#18384c',
      fontSize: '15px !important',
      borderBottom: '1px solid #edf2f4 !important',
    },

    '& .MuiTablePagination-root': {
      color: '#526b7a',
      borderTop: '1px solid #e6eef2',
    },
  },

  caseLink: {
    color: '#0b7894',
    fontWeight: 800,
    textDecoration: 'none',

    '&:hover': {
      color: '#075f75',
      textDecoration: 'underline',
    },
  },

  patientName: {
    color: '#173247',
    fontWeight: 700,
  },

  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 118,
    minHeight: 32,
    padding: '6px 12px',
    borderRadius: 999,
    fontSize: 13,
    fontWeight: 800,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
  },

  emptyState: {
    padding: '30px 20px',
    color: '#6c808c',
    textAlign: 'center',
    fontSize: 16,
  },

  loadingScreen: {
    position: 'fixed',
    top: 72,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    background: '#ffffff',
  },

  loadingLogoWrap: {
    width: 'min(680px, 62vw)',
    maxWidth: 'calc(100vw - 48px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.down('sm')]: {
      width: 'min(520px, 78vw)',
    },

    [theme.breakpoints.down('xs')]: {
      width: 'min(390px, 86vw)',
    },
  },

  loadingLogo: {
    display: 'block',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    background: 'transparent',
    filter: 'none',
  },
}));

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Arial, Helvetica, sans-serif',
    h6: {
      fontSize: '1.25rem',
      fontWeight: 800,
      color: '#173247',
    },
  },
  palette: {
    primary: {
      main: '#0f879f',
    },
  },
});

const statusLabels = {
  Purchase_Order: 'Waiting For MRI',
  MRI: 'In Progress',
  MRI_QC: 'In Progress',
  Planning_1: 'In Progress',
  Planning_2: 'Approval Ready',
  Surgeon_approval: 'Surgeon Approved',
  Template_design: 'Manufacturing',
  G_code: 'Manufacturing',
  CNC: 'Manufacturing',
  Final_QC: 'Manufacturing',
  Shipped: 'Shipped',
  Surgeon_Rejected: 'Surgeon Rejected',
};

const getStatusStyle = (status) => {
  if (status === 'Surgeon_Rejected') {
    return {
      background: '#fff0f0',
      color: '#b42318',
      border: '1px solid #f6c7c7',
    };
  }

  if (status === 'Shipped') {
    return {
      background: '#e8f7fb',
      color: '#08728c',
      border: '1px solid #b9e3ec',
    };
  }

  if (status === 'Planning_2') {
    return {
      background: '#fff7e6',
      color: '#9a6700',
      border: '1px solid #f0d49b',
    };
  }

  if (status === 'Surgeon_approval') {
    return {
      background: '#edf8f1',
      color: '#1f7a45',
      border: '1px solid #c5e7d2',
    };
  }

  if (['Template_design', 'G_code', 'CNC', 'Final_QC'].includes(status)) {
    return {
      background: '#f2effb',
      color: '#6548a5',
      border: '1px solid #d9d0ef',
    };
  }

  return {
    background: '#eef5f8',
    color: '#3f6476',
    border: '1px solid #d3e1e7',
  };
};

const PatientCaseList = () => {
  const { token, role, user, setAuthenticated, setAuthBody } = useContext(AuthorizeContext);
  const [data, setData] = useState({});
  const classes = useStyles();
  let { emailId } = useParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (emailId) {
        const res = await axios({
          url: `https://${api_url}/api/case_list?surgeon=${user.Email_Address}`,
          method: 'get',
          headers: {
            'x-access-token': token
          }
        });
        setLoading(false);
        setData({ data: res.data });
      } else {
        const active = await axios({
          url: `https://${api_url}/api/case_list?surgeon=${user.Email_Address}&status=active`,
          method: 'get',
          headers: {
            'x-access-token': token
          }
        });
        setLoading(false);
        setData({ data: active.data });
      }
    };

    fetchData();
  }, []);

  const [state] = useState({
    columns: [
      {
        title: 'Case #',
        field: 'case_id',
        editable: 'never',
        defaultSort: 'asc',
        cellStyle: {
          minWidth: 130,
          fontSize: '15px',
          padding: '18px 16px',
        },
        render: rowData => {
          if (role === 'mri_center') {
            return (
              <Link className={classes.caseLink} to={`/patient/${rowData.case_id}`}>
                {rowData.case_id}
              </Link>
            );
          }

          return (
            <Link className={classes.caseLink} to={`/case/${rowData.case_id}`}>
              {rowData.case_id}
            </Link>
          );
        },
      },
      {
        title: 'Patient Name',
        field: 'Patient.Last_Name',
        editable: 'never',
        cellStyle: {
          minWidth: 180,
          padding: '18px 16px',
        },
        render: rowData => (
          <span className={classes.patientName}>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
          </span>
        ),
      },
      {
        title: 'Order Date',
        field: 'dateCreated',
        editable: 'never',
        type: 'date',
        cellStyle: {
          minWidth: 145,
          padding: '18px 16px',
          whiteSpace: 'nowrap',
        },
        render: rowData => rowData.dateCreated,
        customSort: (a, b) => {
          a = new Date(a.dateCreated);
          b = new Date(b.dateCreated);
          return b > a ? 1 : -1;
        },
      },
      {
        title: 'Surgery Date',
        field: 'Patient.Date_of_Surgery',
        editable: 'never',
        type: 'date',
        cellStyle: {
          minWidth: 145,
          padding: '18px 16px',
          whiteSpace: 'nowrap',
        },
        customSort: (a, b) => {
          a = moment(a.Patient.Date_of_Surgery).format();
          b = moment(b.Patient.Date_of_Surgery).format();
          return b > a ? 1 : -1;
        },
      },
      {
        title: 'Surgery Type',
        field: 'Patient.Surgery_Type',
        editable: 'never',
        cellStyle: {
          minWidth: 125,
          padding: '18px 16px',
          textAlign: 'center',
        },
        headerStyle: {
          textAlign: 'center',
        },
      },
      {
        title: 'Surgery Side',
        field: 'Patient.Side_of_Body',
        editable: 'never',
        cellStyle: {
          minWidth: 125,
          padding: '18px 16px',
          textAlign: 'center',
        },
        headerStyle: {
          textAlign: 'center',
        },
      },
      {
        title: 'Status',
        field: 'case_status',
        lookup: statusLabels,
        cellStyle: {
          minWidth: 165,
          padding: '14px 16px',
          textAlign: 'center',
        },
        headerStyle: {
          textAlign: 'center',
        },
        render: rowData => (
          <span
            className={classes.statusBadge}
            style={getStatusStyle(rowData.case_status)}
          >
            {statusLabels[rowData.case_status] || rowData.case_status}
          </span>
        ),
      },
    ]
  });

  if (state.data) {
    if (state.data.notLoggedIn) {
      setAuthenticated(false);
      setAuthBody({ role: 'visitor' });
      alert('You have been logged out due to inactivity. Please log in again.');
    }
  } else if (loading) {
    return (
      <div className={classes.loadingScreen}>
        <div className={classes.loadingLogoWrap}>
          <img
            className={classes.loadingLogo}
            src={logo}
            alt="Lento Medical Innovation"
          />
        </div>
      </div>
    );
  }

  const pageTitle = emailId ? 'Order History' : 'Current Orders';
  const pageSubtitle = emailId
    ? 'Review previously created patient orders.'
    : 'Review active patient orders and quickly open a case for more details.';

  return (
    <main className={classes.page}>
      <div className={classes.shell}>
        <section className={classes.hero}>
          <p className={classes.eyebrow}>Surgeon Portal</p>
          <h1 className={classes.heroTitle}>{pageTitle}</h1>
          <p className={classes.heroSubtitle}>{pageSubtitle}</p>
        </section>

        <section className={classes.tableCard}>
          <ThemeProvider theme={theme}>
            <MaterialTable
              title=""
              columns={state.columns}
              data={data.data || []}
              icons={tableIcons}
              localization={{
                pagination: {
                  labelDisplayedRows: '{from}-{to} of {count}'
                },
                toolbar: {
                  nRowsSelected: '{0} row(s) selected',
                  searchPlaceholder: 'Search orders'
                },
                header: {
                  actions: 'Edit'
                },
                body: {
                  emptyDataSourceMessage: 'No orders to display',
                  filterRow: {
                    filterTooltip: 'Filter'
                  }
                }
              }}
              options={{
                actionsColumnIndex: 8,
                sorting: true,
                showTitle: false,
                search: true,
                searchAutoFocus: false,
                debounceInterval: 300,
                pageSize: 20,
                pageSizeOptions: [10, 20, 50],
                emptyRowsWhenPaging: false,
                headerStyle: {
                  color: '#405d70',
                  fontSize: '15px',
                  fontWeight: 800,
                  padding: '16px'
                },
                searchFieldStyle: {
                  width: 280,
                  fontSize: '16px'
                },
                rowStyle: {
                  height: 62
                }
              }}
              style={{
                width: '100%',
                fontSize: '15px',
                boxShadow: 'none'
              }}
            />
          </ThemeProvider>
        </section>
      </div>
    </main>
  );
};

export default PatientCaseList;